import { RiAddLine, RiBookOpenLine } from "@remixicon/react";
import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { useWikiTree } from "@/routes/_app/wiki";

export const Route = createFileRoute("/_app/wiki/")({
	component: WikiIndex,
});

function WikiIndex() {
	const { pages, isLoading } = useWikiTree();

	if (isLoading) return null;

	if (pages.length === 0) {
		return (
			<div className="flex h-full flex-col items-center justify-center gap-4 text-muted-foreground">
				<RiBookOpenLine className="size-16 opacity-30" />
				<div className="text-center">
					<h2 className="text-lg font-medium text-foreground">Create your first page</h2>
					<p className="mt-1 text-sm">Start building your knowledge base</p>
				</div>
				<Button
					onClick={() => {
						// Click the "New page" button in the tree sidebar
						const btn = document.querySelector("[data-slot='sheet-content'] button, aside button");
						if (btn instanceof HTMLButtonElement) btn.click();
					}}
				>
					<RiAddLine className="mr-2 size-4" />
					New Page
				</Button>
			</div>
		);
	}

	return (
		<div className="flex h-full flex-col items-center justify-center gap-4 text-muted-foreground">
			<RiBookOpenLine className="size-16 opacity-30" />
			<div className="text-center">
				<h2 className="text-lg font-medium text-foreground">Select a page</h2>
				<p className="mt-1 text-sm">Choose a page from the sidebar to get started</p>
			</div>
		</div>
	);
}
